import {
  forwardRef,
  MouseEvent as ReactMouseEvent,
  type PropsWithChildren,
} from 'react';

import { Menu } from '../../../../navigation/menu/Menu.js';
import { renderMenuActionChildren } from '../../utils/render-menu-action-children.js';
import { TooltipActionTemplate } from '../tooltip/shared/types/tooltip-action-template.js';

export interface ChartActionsMenuProps {
  /** Controlled open or closed state */
  isOpen: boolean;
  /** Series actions to display **/
  actions?: TooltipActionTemplate;
  /** Handler for the action click */
  onActionClick?: (e: ReactMouseEvent) => void;
}

/**
 * ChartActionsMenu component.
 */
export const ChartActionsMenu = forwardRef<
  HTMLDivElement,
  PropsWithChildren<ChartActionsMenuProps>
>((props: PropsWithChildren<ChartActionsMenuProps>, forwardedRef) => {
  const { children, isOpen, actions, onActionClick } = props;

  return (
    <div onClick={onActionClick}>
      <Menu open={isOpen} modal={false}>
        <Menu.Trigger>{children}</Menu.Trigger>
        {isOpen && (
          <Menu.Content ref={forwardedRef} side="right">
            {actions && renderMenuActionChildren(actions()?.props.children)}
          </Menu.Content>
        )}
      </Menu>
    </div>
  );
});

(
  ChartActionsMenu as typeof ChartActionsMenu & { displayName: string }
).displayName = 'ChartActionsMenu';
